import type { FormCapabilities } from 'app/utils/applications/formCapabilities'

interface GetDisabledSectionsOptions {
  isTicaActive: boolean
  ballotsEnabled: boolean
  isQLDForm22: boolean
  resolvedFormCapabilities: FormCapabilities
}

/**
 * Computes which sections should be disabled in the applicant details sidebar menu.
 *
 * Other Info menu visibility follows form capabilities.
 */
export const getDisabledSections = ({
  isTicaActive,
  ballotsEnabled,
  isQLDForm22,
  resolvedFormCapabilities,
}: GetDisabledSectionsOptions): string[] => {
  const disabledSections: string[] = []

  // TICA check - disabled when TICA integration is not active
  if (!isTicaActive) {
    disabledSections.push('ticaCheck')
  }

  // Background check - disabled when ballots are enabled
  if (ballotsEnabled) {
    disabledSections.push('backgroundCheck')
  }

  // QLD Form 22 always disables studentDetails and emergencyContact (takes precedence)
  if (isQLDForm22) {
    disabledSections.push('studentDetails', 'emergencyContact')
  } else {
    // Form capabilities only apply for non-QLD forms
    if (!resolvedFormCapabilities.hasEmergencyContacts) {
      disabledSections.push('emergencyContact')
    }
    if (!resolvedFormCapabilities.hasStudentDetails) {
      disabledSections.push('studentDetails')
    }
  }

  // Employment details - form capability check (applies to all forms)
  if (!resolvedFormCapabilities.hasEmploymentDetails) {
    disabledSections.push('employmentDetails')
  }

  // Pet details - form capability check (applies to all forms)
  if (!resolvedFormCapabilities.hasPetDetails) {
    disabledSections.push('petDetails')
  }

  // Other info - form capability check (applies to all forms)
  if (!resolvedFormCapabilities.hasOtherInfo) {
    disabledSections.push('otherDocuments')
  }

  return disabledSections
}
